import React from 'react';
import { Toolbar } from '@mui/material';
import OrderForm from './OrderForm';
import useStyles from './styles';

export default function Home() {
  const classes = useStyles();

  return (
    <>
      <Toolbar className={classes.mainHeader}>
        Betafence Configurator
      </Toolbar>
      <OrderForm />
    </>
  );
}
